import "core-js/modules/es6.function.name";
import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "product-modal",
  props: ["title", "from", "product", "value"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      data: {
        product_name: "",
        product_type: "",
        license_interface: "",
        affect: "",
        product_status: 0
      },
      rules: {
        product_name: {
          type: "string",
          required: true,
          min: 2
        },
        product_type: {
          type: "string",
          required: true,
          min: 2
        },
        license_interface: {
          type: "string",
          required: true
        },
        affect: {
          type: "string",
          required: true
        }
      },
      licenseinterfaces: [],
      loading: false
    };
  },
  methods: {
    onLoad: function onLoad() {
      var _this = this;
      if (this.from === "update" && this.product) {
        var p = this.product;
        var data = this.data;
        for (var _i = 0, _arr = ["product_name", "product_type", "license_interface", "affect"]; _i < _arr.length; _i++) {
          var key = _arr[_i];
          data[key] = p[key];
        }
      }
      Axios.get('activation/license-interfaces/').then(function (res) {
        _this.licenseinterfaces = res.data.licenseinterfaces;
        _this.data.license_interface = res.data.licenseinterfaces[0].name;
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;
      var data = this.data;
      this.loading = true;
      var url = this.from === "update" ? "fenxiang/update_config/" : "fenxiang/send_config/";
      var json = {
        product_name: data.product_name,
        product_type: data.product_type,
        license_interface: data.license_interface,
        affect: data.affect,
        product_status: data.product_status
      };
      if (this.from === "update") {
        this.id = this.product.id;
        delete json.product_status;
      }
      return Axios.post(url, json).then(function () {
        return _this2.loading = false;
      }, function (e) {
        _this2.loading = false;
        throw e;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.loading = false;
    }
  }
};